// STY-445: geo signal for the PostHog capture-mode model on react-submissions. Mirrors the
// react-frontend / nextjs helpers (isEuVisitor / hasGlobalPrivacyControl). react-submissions is a
// static CRA app served from S3 — there is NO SSR middleware to set the geo_eu cookie — so when the
// cookie is absent we resolve geo from the dynamic /api-nextjs/geo route (same fallback nextjs uses),
// which sets the .stylemepretty.com geo_eu cookie this app then reads. The app runs under
// www.stylemepretty.com/submissions, so /api-nextjs/geo is same-origin (proxied to the nextjs app).

// CCPA opt-out preference signal (Global Privacy Control).
export function hasGlobalPrivacyControl () {
  if (typeof window === 'undefined' || typeof navigator === 'undefined') return false
  return navigator.globalPrivacyControl === true
}

// Read the geo_eu cookie. true for EU/EEA/UK/CH (+CA) strict regime, OR when the signal is missing
// (fail-safe to strict). false only with positive evidence of a non-strict visitor.
export function isEuVisitor () {
  if (typeof document === 'undefined') return true
  const match = document.cookie.match(/(?:^|; )geo_eu=([01])/)
  if (!match) return true
  return match[1] === '1'
}

// Resolve geo when the geo_eu cookie is absent by pinging /api-nextjs/geo (which sets the cookie).
// Cached per page-load so PostHog init shares one fetch. Resolves immediately if already present.
// Fail-safe: on any error the cookie stays absent and isEuVisitor() returns true (strict/cookieless).
let geoResolvePromise = null
export function ensureGeoResolved () {
  if (typeof document === 'undefined') return Promise.resolve()
  if (/(?:^|; )geo_eu=[01]/.test(document.cookie)) return Promise.resolve()
  if (!geoResolvePromise) {
    geoResolvePromise = fetch('/api-nextjs/geo', { credentials: 'same-origin' })
      .then(() => undefined)
      .catch(() => undefined)
  }
  return geoResolvePromise
}
